var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlockpin = function SvgBlockpin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M11.75 7.75c-.879 0-1.741.234-2.5.677V4.625a4.375 4.375 0 0 0-8.75 0v8.75a4.375 4.375 0 0 0 7.678 2.867A4.998 4.998 0 1 0 11.75 7.75m0 1.25a3.75 3.75 0 0 1 3.694 3.125H8.056A3.75 3.75 0 0 1 11.75 9m-10-4.375a3.125 3.125 0 0 1 6.25 0v3.75H1.75zM4.875 16.5a3.13 3.13 0 0 1-3.125-3.125v-3.75h6.103a4.97 4.97 0 0 0-.452 5.582A3.12 3.12 0 0 1 4.875 16.5m6.875 0a3.75 3.75 0 0 1-3.694-3.125h7.388A3.754 3.754 0 0 1 11.75 16.5"
  })));
};
export default SvgBlockpin;